<p-treeselect
  [(ngModel)]="selectedAccount"
  [options]="accounts"
  (onNodeSelect)="onSelect($event)"
  (onClear)="onClear()"
  (onShow)="onShow()"
  (onBlur)="handleBlur()"
  [loading]="loading"
  [disabled]="disabled"
  [filter]="true"
  [showClear]="true"
  fluid="true">

  <ng-template #header>
      <div class="font-medium px-3 py-2">{{selectionHeader}}</div>
  </ng-template>

  <ng-template #dropdownicon>
    <i class="pi pi-search"></i>
  </ng-template>
</p-treeselect>